$(document).ready(function () {
    'use strict';

    $('.js_mobileVideoTrigger').on('click', function() {
        $('.videoOverlay').trigger('click');
    });
});